import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Driver, DriverService } from '@uzurv/clara';
import { isNullOrUndefined } from '@uzurv/core';
import { AlertDialogComponent } from '../../dialogs/alert-dialog/alert-dialog.component';

@Component({
  selector: 'app-transit-program-driver-search',
  templateUrl: './transit-program-driver-search.component.html',
  styleUrls: ['./transit-program-driver-search.component.scss']
})
export class TransitProgramDriverSearchComponent implements OnChanges {

  @Input() placeholder = 'First Name, Last Name, Phone Number, Transit Program Identifier';
  @Input() autocomplete = true;
  @Input() autocompleteThreshold = 5;
  @Input() pageNumber = 0;
  @Input() pageSize = 10;
  @Input() disabled = false;
  @Input() showResults = true;

  @ViewChild('transitProgramDriverSearchForm', { static: true }) transitProgramDriverSearchForm: NgForm;

  @Output() searchInitiatedHandler: EventEmitter<string> = new EventEmitter<string>();
  @Output() searchResultsFoundHandler: EventEmitter<Array<Driver>> = new EventEmitter<Array<Driver>>();
  @Output() searchResultSelectedHandler: EventEmitter<Driver> = new EventEmitter<Driver>();

  searchString: string;
  searchResults: Array<Driver>;

  private minimumSearchQueryLength = 3;

  constructor(private driverService: DriverService, private dialog: MatDialog) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes['transitProgram']) {
      this.handleTransitProgramChange();
    }

    if (changes['pageNumber'] || changes['pageSize']) {
      if (this.searchString && this.searchString.length > 0) {
        if (
          changes['pageNumber'] &&
          !isNullOrUndefined(changes['pageNumber']['previousValue']) &&
          !isNullOrUndefined(changes['pageNumber']['currentValue']) &&
          changes['pageNumber']['previousValue'] !== changes['pageNumber']['currentValue']
        ) {
          this.performSearch(this.autocomplete);
        } else if (
          changes['pageSize'] &&
          !isNullOrUndefined(changes['pageSize']['previousValue']) &&
          !isNullOrUndefined(changes['pageSize']['currentValue']) &&
          changes['pageSize']['previousValue'] !== changes['pageSize']['currentValue']
        ) {
          this.performSearch(this.autocomplete);
        }
      }
    }
  }

  handleTransitProgramChange() {
    this.searchResults = null;
    this.transitProgramDriverSearchForm.resetForm();
  }

  onKeyUp(event) {
    if (this.searchString.length === 0) {
      this.searchResults = null;
    }

    if (this.autocomplete && this.searchString.length > this.autocompleteThreshold && this.searchString.length % 2 === 0) {
      this.performSearch(true);
    }
  }

  performSearch(isAutocomplete?: boolean) {
    // Check validation
    if (!this.searchString) {
      this.dialog.open(AlertDialogComponent, {
        data: {
          title: 'No Search Query',
          message: 'Please enter a search query'
        }
      });
      return;
    }

    if (this.searchString.length < this.minimumSearchQueryLength) {
      this.dialog.open(AlertDialogComponent, {
        data: {
          title: 'Search Text Too Short',
          message: 'The minimum length of a search must be 3 characters'
        }
      });
      return;
    }

    // Only send this if it's a direct action, otherwise this would be called for every character
    if (!isAutocomplete) {
      this.searchInitiatedHandler.emit(this.searchString);
    }

    this.driverService.searchForDriver(this.searchString, this.pageNumber, this.pageSize).subscribe(
      results => {
        this.searchResultsFoundHandler.emit(results);
        this.searchResults = results;
      },
      err => {
        let message = err.message;
        if (err.message.includes('name does not have the minimum length')) {
          message = 'The minimum length of a search must be 3 characters';
        }
        this.dialog.open(AlertDialogComponent, {
          data: {
            title: 'Error',
            message: message
          }
        });
      }
    );
  }

  selectSearchResult(driver: Driver) {
    this.searchResultSelectedHandler.emit(driver);
    this.searchResults = null;
    this.transitProgramDriverSearchForm.resetForm();
  }
}
